import axios from "../BASE_API";
import AuthHeader from "../AuthHeader";

export class ProductAPI {

  allProduct: any = (data: any) => {
    return axios.post("/product/list", data, { headers: AuthHeader() });
  };

  allReview: any = (data: any) => {
    return axios.post("/product-review/list", data, { headers: AuthHeader() });
  };

  activeProductList: any = () => {
    return axios.get("/product/activeList", { headers: AuthHeader() });
  };

  createNewProduct: any = (data: any) => {
    return axios.post("/product/add", data, { headers: AuthHeader() });
  };

  changeProductStatusById: any = (id: number) => {
    return axios.put(
      "/product/changeStatus",
      { id: id },
      { headers: AuthHeader() }
    );
  };

  deleteProduct: any = (id: number) => {
    return axios.delete("/product/delete", {
      data: { id: id },
      headers: AuthHeader(),
    });
  };

  deleteProductImage: any = (id: number) => {
    return axios.delete("/product/delete-product-image", {
      data: { id: id },
      headers: AuthHeader(),
    });
  };

  getProductById: any = (id: number) => {
    return axios.get(`/product/details/${id}`, { headers: AuthHeader() });
  };

  updateProductOtherInfo: any = (data: any) => {
    return axios.put("/product/update-other-information", data, {
      headers: AuthHeader(),
    });
  };

  updateCropDisease: any = (data: any) => {
    return axios.put("/product/update-crop-disease", data, {
      headers: AuthHeader(),
    });
  };

  updateProduct: any = (data: any) => {
    return axios.put("/product/update", data, {
      headers: AuthHeader(),
    });
  };

  
}
